import type { CSSProperties } from 'react';
import fieldwiseMark from './assets/fieldwise-mark.png';

interface BrandLockupProps {
  compact?: boolean;
}

export function BrandLockup({ compact = false }: BrandLockupProps) {
  const markStyle = {
    '--fieldwise-mark-image': `url(${fieldwiseMark})`,
  } as CSSProperties;

  return (
    <div className={`brand-lockup${compact ? ' compact' : ''}`} aria-label="FieldWise Sign">
      <span className="brand-mark" style={markStyle} aria-hidden="true" />
      <span className="brand-wordmark">
        <span><strong>FieldWise</strong><em>Sign</em></span>
      </span>
    </div>
  );
}
